import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useReveal } from '../../hooks/useReveal';

const Methodology = () => {
  const { t } = useLanguage();
  const [ref, visible] = useReveal();

  const steps = ['m1', 'm2', 'm3', 'm4', 'm5'];

  return (
    <section id="methodology" ref={ref} className="py-24 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0A1628]">{t('method.title')}</h2>
          <div className="w-16 h-1 bg-[#00B4D8] mx-auto mt-6 rounded-full" />
        </div>
        <div className="relative">
          <div className="hidden lg:block absolute top-8 start-0 end-0 h-0.5 bg-slate-200" />
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-4">
            {steps.map((key, i) => (
              <div key={i} data-testid={`method-step-${i}`}
                className={`relative text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                style={{ transitionDelay: visible ? `${100 + i * 100}ms` : '0ms' }}>
                <div className="relative z-10 w-16 h-16 bg-[#0A1628] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <span className="text-[#00B4D8] font-bold text-lg">{String(i + 1).padStart(2, '0')}</span>
                </div>
                <p className="font-semibold text-sm text-[#0A1628]">{t(`method.${key}`)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Methodology;
